import { Route, Routes as Switch } from "react-router-dom";
import { DynamicWidgetLayout } from "shared/components/layouts/DynamicWidgetLayout";
import NotFoundPage from "shared/components/common/NotFoundPage";

const Routes = () => {
  return (
    <Switch>
      <Route
        path={`adaptix/:project/:widget/*`}
        element={<DynamicWidgetLayout />}
      />

      {/* TODO: Create invalid URL component */}
      <Route path="*" element={<NotFoundPage />} />
    </Switch>
  );
};

export default Routes;
